import { useContext } from 'react';

import { TaskDetailActionsContext } from './task-detail-context';

export const useOpenTaskDetail = () => {
  const { openTaskDetail } = useContext(TaskDetailActionsContext);

  return openTaskDetail;
};
